var bus = require('com/js/bus.js');

var Vue = require('vue');
// 配置vue 生产环境配置为true
Vue.config.debug = false;

//加载异步请求插件
var vueResource = require('vue-resource');
Vue.use(vueResource);
// 配置请求根域名


Vue.http.options.root = window.location.origin;
// 伪装为formData数据类型
Vue.http.options.emulateJSON = true;

Vue.http.options.credentials = true
Vue.http.options.xhr = { withCredentials: true }


if (process.env.NODE_ENV == 'host')
	Vue.http.options.root = 'https://dev.web.joyincar.cn';
else Vue.http.options.root = window.location.origin;




//增加token，由于token是放在参数中的，所以需要参数合并
//由于get方式params本身里又有params参数包装
// Vue.http.get=(url,params)=>{
// 	if(params&&params.params) params=Object.assign(params.params,{token:'1',source:'2'})
// 	else params=Object.assign({params:{token:'1',source:'2'}})
// 	return Vue.http.get(url,params)
// }





var md5 = require('md5')
var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
var guid = () => {
	var chars = CHARS, uuid = new Array(36), rnd = 0, r;
	for (var i = 0; i < 36; i++) {
		if (i == 8 || i == 13 || i == 18 || i == 23) {
			uuid[i] = '-';
		} else if (i == 14) {
			uuid[i] = '4';
		} else {
			if (rnd <= 0x02) rnd = 0x2000000 + (Math.random() * 0x1000000) | 0;
			r = rnd & 0xf;
			rnd = rnd >> 4;
			uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
		}
	}
	return uuid.join('');
}




let key = 'E727FF9FE8286779EAD4138A5994B861'
var createHeader = () => {
	//鉴权签名算法
	//SeqNo：唯一请求序列号，客户端识别码(0W代表web端，0I代表ios端，0A代表Android端)+UUID
	let TimeStamp = parseInt(new Date().getTime() / 1000), SeqNo = '0W' + guid(), SignTemp, Sign
	SignTemp = 'SeqNo=' + SeqNo + '&TimeStamp=' + TimeStamp + '&Key=' + key
	Sign = md5(SignTemp).toUpperCase()

	return {
		TimeStamp,
		SeqNo,
		Sign
	}
}




// 配置请求凭证,header中


// 局部配置模板
// new Vue({

//   http: {
//     root: '/root',
//     headers: {
//       Authorization: 'Basic YXBpOnBhc3N3b3Jk'
//     }
//   }

// })




// 注册异步loading全局组件
Vue.component('async-load-tip', require('c/async_loading/async_loading.vue'));
Vue.component('async-load-tip-rem', require('c/async_loading/async_loading_rem.vue'));



// 请求拦截器
Vue.http.interceptors.push(function (request, next) {
	//只能在当前域名下添加headers，第三方域名会不支持

	if (request && request.root && request.url && (request.url.indexOf('http') == -1 && request.url.indexOf('https') == -1)) {


		var car_rental_userinfo = { token: '', source: 'WxPublic', user_id: '' }
		if (localStorage.getItem('car_rental_web_token')) {
			car_rental_userinfo = JSON.parse(localStorage.getItem('car_rental_web_token'))
			car_rental_userinfo.source = 'WxPublic'
		}

		let deta = createHeader()

		request.credentials = true

		//url拼接，前缀root
		/*vueResource只设置root没用，只能拦截器处理*/
		request.url = request.root + "/" + request.url

		request.headers.set('Token', car_rental_userinfo.token)
		request.headers.set('Source', car_rental_userinfo.source)
		request.headers.set('UserId', car_rental_userinfo.user_id + '')
		request.headers.set('AppVersion', '')
		request.headers.set('MobileModel', '')
		//加入鉴权机制
		request.headers.set('TimeStamp', deta.TimeStamp + '')
		request.headers.set('SeqNo', deta.SeqNo)
		request.headers.set('Sign', deta.Sign + '')
	}
	// 发布异步开始加载事件
	bus.$emit('begin-async');

	next(function (response) {


		let temp = /order_red_packet/.test(window.location.href);
		// 如果temp为true则不执行token失效自动跳转登陆的逻辑
		
		if (response && response.body && response.body.result && response.body.result == 20009&&!temp) {
			//清除Storage  token信息和userid信息
			localStorage.removeItem('car-rent-userinfo')
			localStorage.removeItem('rent-car-userinfo')
			localStorage.removeItem('car_rental_web_token')
			window.location.href = 'login.html' + '?back=true'
		}
		// return response
		// 发布结束异步加载事件
		bus.$emit('over-async');
	})
})

// 注册日期顾虑器
// Vue.filter('', function (value) {
//   return value.split('').reverse().join('')
// });

Vue.filter('toLocaleDate', function (value) {

	var ms = (+value) * 1000;
	var date = new Date(ms);

	var year = date.getFullYear();
	var mouth = date.getMonth() + 1;
	if (mouth < 10) {
		mouth = '0' + mouth;
	};

	var day = date.getDate();
	if (day < 10) {
		day = '0' + day;
	};
	var hours = date.getHours();
	if (hours < 10) {
		hours = '0' + hours;
	};
	var minutes = date.getMinutes();
	if (minutes < 10) {
		minutes = '0' + minutes;
	};

	return year + '-' + mouth + '-' + day + '  ' + hours + ':' + minutes;
});

Vue.filter('toLocaleDate2', function (value) {

	var ms = (+value) * 1000;
	var date = new Date(ms);

	var year = date.getFullYear();
	var mouth = date.getMonth() + 1;
	if (mouth < 10) {
		mouth = '0' + mouth;
	};

	var day = date.getDate();
	if (day < 10) {
		day = '0' + day;
	};
	var hours = date.getHours();
	if (hours < 10) {
		hours = '0' + hours;
	};
	var minutes = date.getMinutes();
	if (minutes < 10) {
		minutes = '0' + minutes;
	};

	return year + '/' + mouth + '/' + day
});
Vue.filter('toLocaleDate3', function (value) {

	var ms = (+value) * 1000;
	var date = new Date(ms);

	var year = date.getFullYear();
	var mouth = date.getMonth() + 1;
	if (mouth < 10) {
		mouth = '0' + mouth;
	};

	var day = date.getDate();
	if (day < 10) {
		day = '0' + day;
	};
	var hours = date.getHours();
	if (hours < 10) {
		hours = '0' + hours;
	};
	var minutes = date.getMinutes();
	if (minutes < 10) {
		minutes = '0' + minutes;
	};

	return year + '.' + mouth + '.' + day
});


Vue.filter('toLocaleDate4', function (value) {

	var ms = (+value) * 1000;
	var date = new Date(ms);

	var year = date.getFullYear();
	var mouth = date.getMonth() + 1;
	if (mouth < 10) {
		mouth = '0' + mouth;
	};

	var day = date.getDate();
	if (day < 10) {
		day = '0' + day;
	};
	var hours = date.getHours();
	if (hours < 10) {
		hours = '0' + hours;
	};
	var minutes = date.getMinutes();
	if (minutes < 10) {
		minutes = '0' + minutes;
	};

	var secconds = date.getSeconds();
	if (secconds < 10) {
		secconds = '0' + secconds;
	};

	return year + '-' + mouth + '-' + day + '  ' + hours + ':' + minutes + ':' + secconds;
});

// 转换时间过滤器
Vue.filter('formatSeconds', function (value) {
	var s, min, h;
	if (value < 60) { return value + '秒' }
	if (60 <= value && value < 3600) {
		min = parseInt(value / 60);
		s = value % 60;
		return min + '分' + s + '秒';
	};

	if (value >= 3600) {
		h = parseInt(value / 3600);
		min = parseInt((value % 3600) / 60);
		s = (value % 3600) % 60;

		return h + '时' + min + '分' + s + '秒';
	}
});

// 转换时间过滤器
Vue.filter('formatSeconds_copy', function (value) {
	var s, min, h;
	if (value < 60) { return value + '秒' }
	if (60 <= value && value < 3600) {
		min = parseInt(value / 60);
		s = value % 60;
		return min + '分' + s + '秒';
	};

	if (value >= 3600) {
		h = parseInt(value / 3600);
		min = parseInt((value % 3600) / 60);
		s = (value % 3600) % 60;

		return h + '时' + min + '分' + s + '秒';
	}
});

// 距离转化器  大于1000米 取整已千米为单位  小于一千米 用米为单位
Vue.filter('distanceTurn', function (value) {
	if (value < 1000) {
		return parseInt(+value) + 'm';
	} else {
		return (value / 1000).toFixed(2) + 'km';
	}
})



// 加载Vuetouch插件
var VueTouch = require('vue-touch');
// change the threshold for all swipe recognizers
VueTouch.config.swipe = {
	threshold: 200
}
Vue.use(VueTouch);


// 注册静态步行导航寻车方法
Vue.prototype.$navLookWalk = function (formLng, formLat, toLng, toLat) {
	var url = ''
		+ 'http://uri.amap.com/navigation?'
		+ 'from='
		+ formLng
		+ ','
		+ formLat
		+ ','
		+ 'startpoint'
		+ '&'
		+ 'to='
		+ toLng
		+ ','
		+ toLat
		+ ','
		+ 'endpoint'
		+ '&'
		+ 'mode=walk'
		+ '&'
		+ 'coordinate=gaode&callnative=0';

	location.href = url;
};


// 注册静态驾驶寻车方法
Vue.prototype.$navLookCar = function (formLng, formLat, toLng, toLat) {
	var url = ''
		+ 'http://uri.amap.com/navigation?'
		+ 'from='
		+ formLng
		+ ','
		+ formLat
		+ ','
		+ 'startpoint'
		+ '&'
		+ 'to='
		+ toLng
		+ ','
		+ toLat
		+ ','
		+ 'endpoint'
		+ '&'
		+ 'mode=car'
		+ '&'
		+ 'coordinate=gaode';


	location.href = url;
};




Vue.prototype.$getUrlParams = function () {
	var search = decodeURI(location.search).slice(1);
	var params = search.split('&');
	var res = {};

	for (var i = 0, p; p = params[i++];) {
		var temp = p.split('=');
		res[temp[0]] = temp[1];
	}

	return res;
};


//gps类型坐标 计算连个坐标点距离
Vue.prototype.$getDisance = function (lat1, lng1, lat2, lng2) {
	function toRad(d) { return d * Math.PI / 180; }
	var dis = 0;
	var radLat1 = toRad(lat1);
	var radLat2 = toRad(lat2);
	var deltaLat = radLat1 - radLat2;
	var deltaLng = toRad(lng1) - toRad(lng2);
	var dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
	return dis * 6378137;
};

//添加顶部警告
Vue.prototype.$appendTopWarn = function (text, dom) {
	let warnDom = document.createElement('div');
	warnDom.setAttribute('class', 'top-warn');
	warnDom.innerHTML = text;


	let firstChild = dom.firstChild.nodeType === 3 ? dom.childNodes[1] : dom.firstChild;

	dom.insertBefore(warnDom, firstChild);
};
module.exports = Vue;




// WEBPACK FOOTER //
// ./dep/vue.js